var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLoginSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_login_selected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u624B\\u673A\\u53F7\\u767B\\u5F55-\\u9A8C\\u8BC1\\u7801",
    transform: "translate(-722, -619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_login_selected",
    transform: "translate(722, 619)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#FFA516",
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2909424,7.11764706 L8.4629649,11.8235294 C8.22156602,12.0588235 7.81923456,12.0588235 7.57783569,11.8235294 L7.65830197,11.8235294 C7.57783567,11.8235294 7.41690309,11.745098 7.33643681,11.6666667 L4.68104916,9.07843138 C4.43965028,8.84313726 4.43965028,8.4509804 4.68104916,8.13725491 C4.92244804,7.90196079 5.32477949,7.90196079 5.64664467,8.13725491 L8.06063344,10.4901961 L12.4862795,6.17647059 C12.7276784,5.94117647 13.1300098,5.94117647 13.3714087,6.17647059 L13.451875,6.25490197 C13.5323413,6.49019608 13.5323413,6.88235294 13.2909424,7.11764706 L13.2909424,7.11764706 Z",
    id: "\\u8DEF\\u5F84",
    stroke: "#FFFFFF",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoginSelected);
export default __webpack_public_path__ + "static/media/icon_login_selected.svg";
export { ForwardRef as ReactComponent };